import {RouteRecordRaw} from 'vue-router';
import {Role} from '../../../records/user.record';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `vehicle/:vehicleId`,
            name: `${rootName}VehicleForm`,
            component: () => import('../../settings/vehicles/VehicleForm.vue'),
            props: (route) => {
                return Object.assign({
                    vehicleId: route.params.vehicleId != 'add' ? route.params.vehicleId : null,
                    snapshot: rootName != 'vehicles',
                    backRouteName: rootName,
                    date: route.query.date ? Number(route.query.date) : null
                });
            },
            meta: {
                roles: [Role.DISPATCHER, Role.ADMIN, Role.CUSTOMER_SERVICE]
            }
        }
    ];
}
